import type { User } from '../users/reducer'
import type { StateWithSubscribers } from './reducer'

export const getSubscribersForJob = (
    state: StateWithSubscribers,
    jobID: JobID,
): User[] => state.subscribers[jobID] || []
